import { Col, Modal, Row, Space, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks";
import RegisterForm from "./components/RegisterForm";
import { toggleLoginModal, setTempEmail } from "../login/redux/LoginSlice";
import { toggleRegisterModal } from "./redux/RegisterSlice";
import RegisterOrgForm from "./components/RegisterOrgForm";
import { useLazyGetProvinceListQuery } from "../../redux/api/SystemApi";
import ConfirmModal from "../common/components/ConfirmModal";
const { TabPane } = Tabs;

const RegisterModal = () => {
    const [error, setError] = useState(false);
    const [visible, setVisible] = useState(false);
    const [cancelVisible, setCancelVisible] = useState(false);
    const [checkDirty, setCheckDirty] = useState(false);
    const [activeKey, setActiveKey] = useState("1");

    const registerState = useAppSelector(state => state.register);
    const userState = useAppSelector(state => state.login);

    const dispatch = useAppDispatch();

    const [provinceTrigger, provinceResponse] = useLazyGetProvinceListQuery();

    useEffect(() => {
        provinceTrigger({ size: 1000, page: 0, status: 1 })
    }, [provinceTrigger])

    const openLogin = () => {
        dispatch(toggleRegisterModal())
        dispatch(toggleLoginModal());
    }

    const toggleVisible = () => {
        setVisible(!visible);
    }

    const toggleCancel = () => {
        setCancelVisible(!cancelVisible);
    }

    const onCancelClick = () => {
        setCheckDirty(true);
    }

    const onOkClick = () => {
        dispatch(toggleRegisterModal())
        if (userState.tempEmail) {
            dispatch(setTempEmail(""))
        }
    }

    return (
        <>
            <Modal
                // width={1000}
                style={{ minWidth: 1000 }}
                visible={registerState.modalVisible}
                onCancel={onCancelClick}
                className="custom-modal"
                footer={false}
                bodyStyle={{ padding: '24px 50px' }}
            >
                <Space style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }} size={20}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: 30 }}>ĐĂNG KÝ</div>
                    <Tabs type="card" className="custom-tab" activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
                        <TabPane tab="CÁ NHÂN" key="1"></TabPane>
                        <TabPane tab="TỔ CHỨC" key="2"></TabPane>
                    </Tabs>
                </Space>
                <div style={{ visibility: error ? 'visible' : 'hidden', color: '#BB4048', textAlign: 'center' }}>Vui lòng nhập đầy đủ thông tin</div>
                <Row align="middle" justify="center">
                    <Col span={24}>
                        {activeKey === "1" ?
                            <RegisterForm
                                onRegisterSuccess={toggleVisible}
                                openLogin={openLogin}
                                province={[...provinceResponse.data?.content || []].sort((a, b) => a.provinceName.localeCompare(b.provinceName))}
                                checkDirty={checkDirty}
                                setCancelVisible={setCancelVisible}
                                setCheckDirty={setCheckDirty}
                            /> : <></>}
                        {activeKey === "2" ?
                            <RegisterOrgForm
                                onRegisterSuccess={toggleVisible}
                                openLogin={openLogin}
                                province={[...provinceResponse.data?.content || []].sort((a, b) => a.provinceName.localeCompare(b.provinceName))}
                                checkDirty={checkDirty}
                                setCancelVisible={setCancelVisible}
                                setCheckDirty={setCheckDirty}
                            /> : <></>}
                    </Col>
                </Row>
                {/* <Row style={{ marginTop: 25 }} align="middle" justify="center">
                    <Col span={24}>
                        <Tabs type="card" className="custom-tab" activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
                            <TabPane tab="CÁ NHÂN" key="1">
                                {activeKey === "1" ?
                                    <RegisterForm
                                        onRegisterSuccess={toggleVisible}
                                        openLogin={openLogin}
                                        province={[...provinceResponse.data?.content || []].sort((a, b) => a.provinceName.localeCompare(b.provinceName))}
                                        checkDirty={checkDirty}
                                        setCancelVisible={setCancelVisible}
                                        setCheckDirty={setCheckDirty}
                                    /> : <></>}
                            </TabPane>
                            <TabPane tab="TỔ CHỨC" key="2">
                                {activeKey === "2" ?
                                    <RegisterOrgForm
                                        onRegisterSuccess={toggleVisible}
                                        openLogin={openLogin}
                                        province={[...provinceResponse.data?.content || []].sort((a, b) => a.provinceName.localeCompare(b.provinceName))}
                                        checkDirty={checkDirty}
                                        setCancelVisible={setCancelVisible}
                                        setCheckDirty={setCheckDirty}
                                    /> : <></>}
                            </TabPane>
                        </Tabs>
                    </Col>
                </Row> */}
            </Modal>
            {visible ?
                <ConfirmModal
                    visible={visible}
                    status="success"
                    onOk={() => dispatch(toggleRegisterModal())}
                    onCancel={() => dispatch(toggleRegisterModal())}
                    noCancelButton
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">Bạn đã đăng ký tài khoản thành công!</div>
                        <div className="font-size-16">Vui lòng xác nhận trong email để bắt đầu đăng nhập</div>
                    </div>}
                /> : <></>}
            {cancelVisible ?
                <ConfirmModal
                    visible={cancelVisible}
                    status="error"
                    onOk={onOkClick}
                    onCancel={toggleCancel}
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">Bạn có chắc chắn muốn thoát và không lưu dữ liệu vừa nhập</div>
                    </div>}
                /> : <></>}
        </>
    )
}

export default RegisterModal;